import { render, staticRenderFns } from "./base-combobox.vue?vue&type=template&id=1553a4b8"
import script from "./base-combobox.ts?vue&type=script&lang=ts&external"
export * from "./base-combobox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1553a4b8')) {
      api.createRecord('1553a4b8', component.options)
    } else {
      api.reload('1553a4b8', component.options)
    }
    module.hot.accept("./base-combobox.vue?vue&type=template&id=1553a4b8", function () {
      api.rerender('1553a4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Combobox/base-combobox.vue"
export default component.exports